import React from "react";
import CareersHeroSection from "../Components/Careers/CareersHeroSection.jsx";
import CareersDescription from "../Components/Careers/CareersDescription.jsx";
import CareersJobs from "../Components/Careers/CareersJobs.jsx";

const CareersPage = () => {
  return (
    <main role="main">
      <CareersHeroSection />
      <CareersDescription />
      <CareersJobs />
    </main>
  );
};

export default CareersPage;
